import { Component, OnInit, Input, ElementRef, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { LocalStorageService } from './../../../../../../shared/services/local-storage/local-storage.service';
import { AdquirenteService } from '../../../../../../shared/services/adquirente/adquirente.service';
import { adquirenteStrings, environment } from './../../../../../../../environments/environment';

@Component({
  selector: 'app-card-adquirente',
  templateUrl: './card-adquirente.component.html',
  styleUrls: ['./card-adquirente.component.scss']
})
export class CardAdquirenteComponent implements OnInit {
  @Input() private adquirenteInput: any;
  @Output() private event: EventEmitter<any> = new EventEmitter();

  public adquirente: any = {
    AdquirenteId: '',
    Nome: '',
    ContaId: '',
    GatewayId: '',
    GatewayKey: '',
    UrlRequicisao: '',
    UrlConsulta: '',
    TipoMeioPagamento: '',
    MeioPagamento: '',
    Padrao: false
  };

  public isEditing = false;
  public isLoading = false;

  constructor(
    private elRef: ElementRef,
    private adquirenteService: AdquirenteService,
    private localStorage: LocalStorageService,
  ) { }

  ngOnInit() {
      if (!this.adquirenteInput) {
        return;
      }

      this.adquirente = this.adquirenteInput;

      if (this.adquirente && this.adquirente.AdquirenteId) {
        this.isEditing = false;
      } else {
        this.isEditing = true;
      }
  }

  submit(e) {
    e.preventDefault();

    this.isLoading = true;

    this.adquirente.Padrao = false;
    this.adquirente.ContaId = this.localStorage.get('login').PersonId;
    this.adquirente.MeioPagamento = adquirenteStrings.meioPagamento;
    this.adquirente.TipoMeioPagamento = adquirenteStrings.tipoMeioPagamento;

    this.adquirenteService.adicionar(this.adquirente).subscribe(() => {
        if (this.elRef.nativeElement.querySelector('.adquirente') && this.elRef.nativeElement.querySelector('.adquirente').classList.contains('animate-card-up-adquirente')) {
          this.elRef.nativeElement.querySelector('.adquirente').classList.remove('animate-card-up-adquirente');
          this.elRef.nativeElement.querySelector('.adquirente').classList.add('animate-card-up-adquirente');
        }

      this.isEditing = false;
      this.isLoading = false;
    }, (err) => {
      console.error(err);

      this.isEditing = true;
      this.isLoading = false;
    });
  }

  adquirentePadrao() {
    this.event.emit({ name: 'default', id: this.adquirente.AdquirenteId });

    this.adquirente.Padrao = true;
    this.adquirente.Validacao = {};

    this.adquirenteService.atualizar(this.adquirente).subscribe(() => { }, (err) => {
      console.error(err);
    });
  }

  selectAdquirente(name) {
    switch (name) {
      case 'Cielo':
      this.adquirente.Nome = environment.production ? 'Cielo' : 'CieloSandBox';
        break;
      case 'Rede':
        this.adquirente.Nome = 'Rede';
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/components/minha-conta/configuracoes/card-adquirente/card-adquirente.component.ts